import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

const withAuthHeader =
  (authToken: string) =>
  (axios: AxiosInstance): AxiosInstance => {
    axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
      if (!authToken) return config;
      else {
        config.headers['Authorization'] = `Bearer ${authToken}`;
        return config;
      }
    });
    return axios;
  };

export default withAuthHeader;
